import { USER_DETAILS } from "@mainrepo/app/core/constants/Constants";

export class UserData{

    constructor(){
        
    }


    setUserDataInGlobalConstant(userData){
        if(userData){
            USER_DETAILS["USER_DETAILS"] = {
                ...USER_DETAILS["USER_DETAILS"],
                ...userData
            };
        }

        console.log("USER_DETAILS",USER_DETAILS);
    }
}